module.exports = __webpack_public_path__ + "static/media/profile-business.6a08d1f1.svg";